// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_c4-b";
export var colorBlue = "_c4-8";
export var colorDot = "_c4-0";
export var colorDotLarge = "_c4-2";
export var colorDotSmall = "_c4-1";
export var colorGreen = "_c4-7";
export var colorGrey = "_c4-3";
export var colorOrange = "_c4-5";
export var colorPink = "_c4-a";
export var colorPurple = "_c4-9";
export var colorRed = "_c4-4";
export var colorYellow = "_c4-6";